const BlogPostData = [
  {
    id: 1,
    imageURL: "trello",
    title: "Why Java is the best programming language?",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully."
  },

  {
    id: 2,
    imageURL: "newspaper",
    title: "Why Java is the best programming language?",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully."
  },

  {
    id: 3,
    imageURL: "books",
    title: "Why Java is the best programming language?",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully."
  },

  {
    id: 4,
    imageURL: "magazine",
    title: "Why Java is the best programming language?",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully."
  },

  {
    id: 5,
    imageURL: "todo",
    title: "Why Java is the best programming language?",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully."
  },

  {
    id: 6,
    imageURL: "magnifyer",
    title: "Why Java is the best programming language?",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully."
  },
]

export default BlogPostData;